import styles from './Heading.module.scss'
import cx from 'classnames'
import React from 'react'

type HeadingProps = {
    children: React.ReactNode
    level: 1 | 2 | 3 | 4 | 5
    classes?: string
}

const Heading = ({ children, level, classes }: HeadingProps) => {
    const className = cx(styles['zr-heading'], classes)

    return (
        <>
            {level === 1 && <h1 className={className}>{children}</h1>}
            {level === 2 && <h2 className={className}>{children}</h2>}
            {level === 3 && <h3 className={className}>{children}</h3>}
            {level === 4 && <h4 className={className}>{children}</h4>}
            {level === 5 && <p className={className}>{children}</p>}
        </>
    )
}

export default Heading
